const frame = (bg = '#FFFFFF') => ({
  backgroundColor: bg,
  paddingTop: '24px',
  paddingBottom: '24px',
  paddingLeft: '24px',
  paddingRight: '24px',
});

/**
 * Starter template: Logo + Text Block
 * Note: FooterSection is excluded — the Designer always renders a permanent footer
 * as a fixed canvas element (see designer.tsx), so it must not be included in templateJson.
 */
export const LESS_SEED_TEMPLATE_JSON = JSON.stringify({
  sections: [
    {
      sectionType: 'LogoSection',
      frame: frame(),
    },
    {
      sectionType: 'TextSection',
      text: '',
      frame: { ...frame(), paddingTop: '16px', paddingBottom: '16px' },
    },
  ],
});

/**
 * Starter template: Logo + Image + Text Block + Button
 * Note: FooterSection is excluded — the Designer always renders a permanent footer
 * as a fixed canvas element (see designer.tsx), so it must not be included in templateJson.
 */
export const MORE_SEED_TEMPLATE_JSON = JSON.stringify({
  sections: [
    {
      sectionType: 'LogoSection',
      frame: frame(),
    },
    {
      sectionType: 'ImageSection',
      imageCount: 1,
      frame: {
        backgroundColor: '#FFFFFF',
        paddingTop: '0px',
        paddingBottom: '0px',
        paddingLeft: '0px',
        paddingRight: '0px',
      },
    },
    {
      sectionType: 'TextSection',
      text: '',
      frame: { ...frame(), paddingTop: '16px', paddingBottom: '16px' },
    },
    {
      sectionType: 'ButtonSection',
      frame: { ...frame(), paddingTop: '16px', paddingBottom: '16px' },
    },
  ],
});
